export interface EditorConfigItem {
  code: string;
  name: string;
  description: string;
}

export interface EditorConfig {
  cleanup?: EditorConfigItem;
  states?: Record<string, EditorConfigItem>;
  actions?: Record<string, EditorConfigItem>;
}

const EDITOR_CONFIG_REGEX = /```vsly\/json\/editor\n([\s\S]*?)\n```/;

export function sanitizeKeyName(key: string): string {
  return key.replace(/[^a-zA-Z0-9_$]/g, `_`);
}

export function extractEditorConfig(content: string): EditorConfig | null {
  if (!content) return null;
  const match = content.match(EDITOR_CONFIG_REGEX);
  if (match && match[1]) {
    try {
      return JSON.parse(match[1]) as EditorConfig;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`Failed to parse editor config JSON`, e);
    }
  }
  return null;
}
